import { render } from "./Brunch.vue?vue&type=template&id=0e2dbca0"
import script from "./Brunch.vue?vue&type=script&lang=js"
export * from "./Brunch.vue?vue&type=script&lang=js"

import "../css/buffet.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__